'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _templates = require('redux/modules/templates');

var _modals = require('constants/modals');

var _modals2 = require('redux/modules/modals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateApplicationSubHeader = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(TemplateApplicationSubHeader, _Component);

  function TemplateApplicationSubHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TemplateApplicationSubHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TemplateApplicationSubHeader.__proto__ || (0, _getPrototypeOf2.default)(TemplateApplicationSubHeader)).call.apply(_ref, [this].concat(args))), _this), _this._onSave = function () {
      var _this$props$templateA = _this.props.templateApplication,
          templates = _this$props$templateA.templates,
          templatesSettings = _this$props$templateA.templatesSettings;
      var temp = templatesSettings.temp;
      var defaultTemplateId = templates.defaultTemplateId,
          removed = templates.removed;

      var templatesList = templates.templates;
      templatesList = (0, _keys2.default)(templatesList).map(function (key) {
        return templatesList[key];
      });

      _this.props.saveTemplateApplicationSettings((0, _stringify2.default)(temp), (0, _stringify2.default)(templatesList), removed, defaultTemplateId, _this.props.codedToken);
    }, _this._onCancel = function () {
      var confirmMessage = 'CHANGES WILL NOT BE SAVED, ARE YOU SURE YOU WANT TO CONTINUE?';
      _this.props.showModal(_modals.CONFIRM, {
        body: confirmMessage,
        onCancel: function onCancel() {
          return _this.props.hideModal(_modals.CONFIRM);
        },
        onConfirm: function onConfirm() {
          _this.props.hideModal(_modals.CONFIRM);
          _this.props.cancelTemplateApplicationSettings();
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TemplateApplicationSubHeader, [{
    key: 'render',
    value: function render() {
      var BTN_SIZES = _components.ENTERPRISE_BUTTON_SIZES;
      var BTN_TYPES = _components.ENTERPRISE_BUTTON_TYPES;
      var styles = require('./TemplateApplicationSubHeader.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('enterprise-subHeader__root', styles.root) },
        _react2.default.createElement(
          'h1',
          { className: (0, _classnames2.default)('enterprise-subHeader__title', styles.title) },
          'Template Application'
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('enterprise-subHeader__actionsWrapper', styles.actionsWrapper) },
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.PRIMARY,
              onClick: this._onSave
            },
            'SAVE'
          ),
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.SECONDARY,
              onClick: this._onCancel
            },
            'CANCEL'
          )
        )
      );
    }
  }]);
  return TemplateApplicationSubHeader;
}(_react.Component), _class.propTypes = {
  codedToken: _react.PropTypes.string,
  templateApplication: _react.PropTypes.object,
  saveTemplateApplicationSettings: _react.PropTypes.func,
  cancelTemplateApplicationSettings: _react.PropTypes.func,
  showModal: _react.PropTypes.func,
  hideModal: _react.PropTypes.func
}, _temp2);


var mapStateToProps = function mapStateToProps(state) {
  return {
    codedToken: state.auth.codedToken,
    templateApplication: state.templateApplication
  };
};

var getActions = function getActions() {
  return {
    saveTemplateApplicationSettings: _templates.saveTemplateApplicationSettings.base,
    cancelTemplateApplicationSettings: _templates.cancelTemplateApplicationSettings,
    showModal: _modals2.show,
    hideModal: _modals2.hide
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, getActions())(TemplateApplicationSubHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateApplication/TemplateApplicationSubHeader/TemplateApplicationSubHeader.jsx
// module id = 1642
// module chunks = 0